import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseRegressContactProps {
  contactId?: string
  onSuccess: () => void
  onError: () => void
}

export const useRegressContact = ({ contactId, onSuccess, onError }: UseRegressContactProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['regressContact'],
    mutationFn: async () => {
      await privateAxios.put(`/funnel/contacts/${contactId}/regress`)
    },
    onSuccess,
    onError,
  })
}
